/** @jsxImportSource theme-ui */
import List from "../List/List";

export default function ProductListsList({ children, ...rest }) {
  return <List {...rest}>{children}</List>;
}
